/**
 * @flow
 * @format
 */

import _ErrorComponent from './ErrorComponent';

export default _ErrorComponent;



// WEBPACK FOOTER //
// ./src/components/ErrorComponent/index.js